


import TiwiMixin from '../mixins/TiwiMixin';
import LikeButton from './LikeButton';
import CommentCard from './CommentCard';
import ContentCard from './ContentCard';
import CommentField from './CommentField';
import CommentsSection from './CommentsSection';

import { mapState } from 'pinia';
import { useMainStore } from '../stores/main'

export default {
  mixins: [TiwiMixin],
  components: {
    LikeButton,
    CommentCard,
    ContentCard,
    CommentField,
    CommentsSection
  },
  mounted: function () {
    this.modal_window = new bootstrap.Modal('#commentModal');
  },
  methods: {
    openModal: function () {
      this.modal_window.show();
    },
    closeModal: function () {
      this.modal_window.hide();
      this.setCommentablePost(null);
    }
  },
  computed: {
    ...mapState(useMainStore, ['commentable_post']),
  },
}
